/**
 * Словарь категорий photo-use-case для краски — два контекста показа фасада.
 *
 * Источник истины: колонка `Категория` в
 * `<BASE_PATH>/Краски/Фасады краска Ралы фото Готов.csv`. Каждый RAL-цвет
 * сфотографирован в двух use case (кухонный фасад + шкаф). Per ADR-0010 §2
 * data model Block 3: 1 row CSV = 1 Paint SKU с полем `category`.
 *
 * Это **photo use case**, не свойство самой краски — RAL 1000 один и тот же,
 * но карточек в каталоге две (одна с фото на кухне, другая с фото на шкафу).
 * UX-дедубликация по `ralCode` — забота presenter (Phase 3).
 *
 * Используется:
 *   - в Zod-схеме `PaintCategorySchema` (`contracts/paint.ts`);
 *   - в UI-фильтрах Phase 3;
 *   - в адаптере `ral-classic.ts` для валидации category из CSV.
 */
export const PAINT_CATEGORIES = Object.freeze(['Кухня', 'Шкаф'] as const);
export type PaintCategory = (typeof PAINT_CATEGORIES)[number];

export function getPaintCategories(): readonly PaintCategory[] {
  return PAINT_CATEGORIES;
}
